<div class="modal-header">
  <h6 class="modal-title text-muted">เพิ่มข้อมูลหน่วยที่ออกจากการคิด POINT</h6>
  <button type="button" class="btn-close" aria-label="Close"
          (click)="close()"></button>
</div>
<form id="{{formId()}}" #form="ngForm" class="form-validate" (submit)="save()">
  <div class="modal-body">
    <div class="row mb-3">
      <label for="hospital" class="col-form-label col-xl-3 ui-require">หน่วยบริการ</label>
      <div class="col-xl-9">
        <app-hospital-autocomplete id="hospital"
                                   name="hospital"
                                   #groupRegisterTypeInput="ngModel"
                                   required
                                   [disabled]="crud != 'CREATE'"
                                   [(ngModel)]="item.hospital"></app-hospital-autocomplete>
        @if (groupRegisterTypeInput.invalid && (groupRegisterTypeInput.dirty || groupRegisterTypeInput.touched)) {
          <custom-error *ngIf="groupRegisterTypeInput.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
    </div>
    <div class="row mb-3">
      <label for="dateOut" class="col-form-label col-xl-3 ui-require">วันที่ออกจากโครงการ</label>
      <div class="col-xl-4">
        <gt-ng-datepicker id="dateOut"
                          name="dateOut"
                          #dateOutInput="ngModel"
                          required
                          (change)="onDateOutChange($event)"
                          [disabled]="crud != 'CREATE'"
                          [(ngModel)]="item.dateOut"></gt-ng-datepicker>
        @if (dateOutInput.invalid && (dateOutInput.dirty || dateOutInput.touched)) {
          <custom-error *ngIf="dateOutInput.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
    </div>
    <div ngbAutofocus class="row">
      <div class="offset-xl-3 col-xl-12">
        <gt-error code="ExcludedHospitalValid"></gt-error>
      </div>
      <div class="col-12">
        <button type="button" class="btn btn-default float-end" (click)="activeModal.close()">ยกเลิก
        </button>
        @if (crud != 'VIEW') {
          <button type="submit" class="btn btn-primary float-end me-2">บันทึก</button>
        }
      </div>
    </div>
  </div>
</form>
